import React, {useCallback, useState} from 'react'
import SnackbarUtils from "../../../../libs/SnackbarUtils";
import { useParams } from "react-router-dom";
import {serviceUpdateUserQueries} from "../../../../services/UserQueries.service"
const initialForm = {
    status: "",
    comment: "",
  };

const useUpdateStatusDialogHook = ({ 
  handleUpdateStatus, renderList }) => {
    const [form, setForm] = useState(
        JSON.parse(JSON.stringify({ ...initialForm }))
      );
      const [errorData, setErrorData] = useState({});
      const [isSubmitting, setIsSubmitting] = useState(false);
      const { id } = useParams();

      const removeError = useCallback(
        (title) => {
          const temp = JSON.parse(JSON.stringify(errorData));
          temp[title] = false;
          setErrorData(temp);
        },
        [setErrorData, errorData]
      );

      const changeTextData = useCallback(
        (text, fieldName) => {
          let shouldRemoveError = true;
          const t = { ...form };
          t[fieldName] = text;
          setForm(t);
          shouldRemoveError && removeError(fieldName);
        },
        [removeError, form, setForm]
      );

      const checkFormValidation = useCallback(() => {
        const errors = { ...errorData };
        let required = ["status", "comment"];
        
        required.forEach((val) => {
          if (
            (!form?.[val] && parseInt(form?.[val]) !== 0) ||
            (Array.isArray(form?.[val]) && form?.[val]?.length === 0)
          ) {
            errors[val] = true;
          }
        });
        
    
        Object.keys(errors).forEach((key) => {
          if (!errors[key]) {
            delete errors[key];
          }
        });
        return errors;
      }, [form, errorData]);

      const submitToServer = useCallback(() => {
        if (!isSubmitting) {
          setIsSubmitting(true);
          serviceUpdateUserQueries({
           id: id,
            ...form,
          }).then((res) => {
            if (!res.error) {
              SnackbarUtils.success("Status updated");
             // historyUtils.goBack();
            //  window.location.reload();
              handleUpdateStatus();
              renderList();
            } else {
              SnackbarUtils.error(res?.message);
            }
            setIsSubmitting(false);
          });
        }
      }, [form, isSubmitting, setIsSubmitting, handleUpdateStatus,renderList]);
    
      const handleSubmit = useCallback(async () => {
        const errors = checkFormValidation();
        if (Object.keys(errors).length > 0) {
          setErrorData(errors);
          return true;
        }
        submitToServer();
      }, [checkFormValidation, setErrorData, form, submitToServer]);
    

      const onBlurHandler = useCallback(
        (type) => {
          if (form?.[type]) {
            changeTextData(form?.[type].trim(), type);
          }
        },
        [changeTextData]
      );

  return {
    changeTextData,
    onBlurHandler,
    handleSubmit,
    errorData 
  }
}

export default useUpdateStatusDialogHook